<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select v-model="query.siteIds[0]" size="small" style="width:150px;" @change="onSiteIdChange">
      <el-option
        v-for="item in filterSites"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-select>

    <el-cascader
      v-if="currentSite"
      :key="query.siteIds[0]"
      v-model="query.factorIds"
      :options="currentDevices"
      size="small"
      :show-all-levels="false"
      :props="{
        value: 'id',
        label: 'name',
        children: 'siteDeviceFactors',
        multiple: true,
        emitPath: false
      }"
      collapse-tags
      placeholder="请选择站房设备"
      class="custom-cascader"
      style="width:max-content;"
    />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <related-matrix-chart
        :query="currentQuery"
        :factor-map="factorMap"
        :data-list="dataList"
        style="flex:1 0 100%;min-height:774px;"
      />
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
    />
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import RelatedMatrixChart from '../../../../components/RelatedMatrixChart/index'
import Editor from './Editor'
import DataFormatter from '../../../../model/DataFormatter'

const MAX_FACTOR_SELECT_NUM = 40

export default {
  name: 'AQIRelatedAnalysis',
  routeInfo: {
    label: '相关性矩阵分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {RelatedMatrixChart, UnitSwitch, DataWrapper, DataTimeQuery, LayoutContent, Editor},
  data: () => ({
    query: {
      isGetInvalidData: false,
      isMultipleIntegral: true
    },
    clickQuery: {}
  }),
  computed: {
    isSetAllFactorIds: () => MAX_FACTOR_SELECT_NUM,
    filterSiteMap () {
      const {profileSiteMap} = this
      const excludeDeviceCategories = {
        [process.env.QI_RONG_JIAO_LIDAR_DEVICE_CATEGORY]: true,
        [process.env.O3_LIDAR_DEVICE_CATEGORY]: true,
        [process.env.LASER_CEILOMETER_DEVICE_CATEGORY]: true,
        [process.env.MICROWAVE_RADIOMETER_DEVICE_CATEGORY]: true,
        [process.env.LIDAR_DEVICE_CATEGORY]: true,
        [process.env.WIND_PROFILE_CATEGORY]: true
      }

      return this.profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        const {categoryId} = siteDevice

        if (excludeDeviceCategories[categoryId]) {
          return map
        }

        const {siteDeviceFactors} = siteDevice

        if (siteDeviceFactors.length === 0) {
          return map
        }

        let tmpSite = map[siteId]

        if (!tmpSite) {
          tmpSite = map[siteId] = {
            id: siteId,
            name: site.name,
            devices: []
          }
        }

        tmpSite.devices.push({
          ...siteDevice,
          siteDeviceFactors: siteDeviceFactors.map(siteDeviceFactor => ({
            ...siteDeviceFactor,
            id: siteDeviceFactor.factorId
          }))
        })

        return map
      }, {})
    },
    filterSites () {
      return Object.values(this.filterSiteMap)
    },
    currentSite () {
      return this.filterSiteMap[this.query.siteIds[0]]
    },
    filterFactorMap () {
      return this.currentSite.devices.reduce((map, device) => device.siteDeviceFactors.reduce((map, deviceFactor) => {
        let {factorId} = deviceFactor

        if (!map[factorId]) {
          let newDeviceFactor = JSON.parse(JSON.stringify(deviceFactor))
          newDeviceFactor.id = factorId
          map[factorId] = newDeviceFactor
        }

        return map
      }, map), {})
    },
    currentDevices () {
      return [...this.currentSite.devices].sort((a, b) => a.siteDeviceFactors[0].factorId - b.siteDeviceFactors[0].factorId)
    }
  },
  methods: {
    _setFactorIds () {
      const factorMap = this.siteFactorMap[this.query.siteIds[0]].map
      let factorIds = [
        '1001',
        '1003',
        '1005',
        '1006',
        '1007',
        '1008',
        '1009',
        '1010',
        '1011',
        '1012',
        '1013',
        '1014',
        '9210',
        '6401',
        '6103',
        '6104',
        '6108',
        '6101',
        '6109',
        '6111',
        '6107',
        '6400',
        '8022',
        '3507',
        '1015',
        '1002'
      ].filter(factorId => factorMap[factorId])

      if (factorIds.length === 0) {
        factorIds = Object.values(factorMap).slice(0, MAX_FACTOR_SELECT_NUM).map(factor => factor.factorId)
      }

      this.query.factorIds = factorIds
    },
    formatData () {
      this.dataList = Object.freeze(this.tmpList)
    },
    onSiteIdChange (siteId) {
      // const {currentQuery, query} = this
      // query.factorIds = currentQuery.siteIds[0] === siteId ? [...currentQuery.factorIds] : this.currentSite.devices.reduce((list, device) => list.length < 50 ? device.siteDeviceFactors.reduce((list, factor) => {
      //   list.push(factor.id)
      //   return list
      // }, list) : list, [])
      const {currentQuery, query} = this

      if (currentQuery.siteIds[0] === siteId) {
        query.factorIds = [...currentQuery.factorIds]
      } else {
        this._setFactorIds()
      }
    },
    getClickCorrelationData () {
      this.changeLoadStatus(true)

      this.$api.Data.getHistoryData(this.clickQuery).then(this.setDataList2).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList2 (dataList) {
      this.tmpList2 = Object.freeze(dataList)
      this.formatData2()
    },
    formatData2 (oDataListProp = 'tmpList2', dataListProp = 'dataList2') {
      console.time('format2')

      let {clickQuery} = this

      if (Object.keys(clickQuery).length === 0) {
        return
      }

      const {valueProp = 'value'} = this

      DataFormatter.format.bind(this)(clickQuery, 'factorId', (data, newData, dimensionIdProp1, ts, dataTime) => {
        let value = data[valueProp]

        if (Number.isFinite(value)) {
          let series = newData.seriesMap[data[dimensionIdProp1]]

          if (series) {
            series.push({
              ...data,
              value,
              ts,
              dataTime,
              flag: data.flag || null,
              dasFlag: data.dasFlag || null,
              auditFlag: data.auditFlag
            })
          }
        }
      }, oDataListProp, dataListProp)

      let refEditor = this.$refs.editor
      let {factorMap, clickQuery: {factorIds}} = this
      let EditorName = factorIds.length === 2 ? (factorMap[factorIds[0]].name + '-' + factorMap[factorIds[1]].name) : factorMap[factorIds[0]].name
      refEditor && refEditor.open({data: this.dataList2, name: EditorName})
      console.timeEnd('format2')
    },
    onCorrelationClick (data) {
      if (!data.factorIds.length) return

      let {query} = this
      let clickQuery = {
        ...query,
        factorIds: [...new Set(data.factorIds)]
      }

      this.clickQuery = Object.freeze(clickQuery)
      this.getClickCorrelationData()
    }
  },
  created () {
    this.$eventBus.on('onCorrelationClick', this.onCorrelationClick)
  },
  beforeDestory () {
    this.$eventBus.off('onCorrelationClick', this.onCorrelationClick)
  }
}
</script>

<style lang="scss" scoped>
.custom-cascader {
  /deep/ {
    .el-cascader__tags {
      display: grid;
      grid-template-columns: minmax(auto, max-content) max-content;

      > :first-child {
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/13AQIRelatedAnalysis/index.vue